import type { TaskDefinitionFormSchema } from "api";
import { api } from "api";
import { type FC, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { TaskDefinitionForm } from "./form";

const defaultValues = {
  id: "",
  image: "",
};

const NewTaskDefinitionRoute: FC = () => {
  const navigate = useNavigate();

  const onSubmit = useMemo(
    () => async (data: TaskDefinitionFormSchema) => {
      const resp = await api.createTaskDefinition(data);
      await navigate(`/task-definitions/${resp.id}`);
    },
    [navigate],
  );

  return (
    <TaskDefinitionForm
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      title="New Task Definition"
      submitButtonText="Create"
      isNew
    />
  );
};

export default NewTaskDefinitionRoute;
